import React from 'react';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { BACKEND_URL } from '../../../configs';

export default function PhotoView({ photo = '', onClose = () => {} }) {
  return (
    <Dialog
      className="photo-view"
      onClose={onClose}
      open
      size="xl"
    >
      <DialogTitle header="Просмотр фото" title={<Icons onClick={onClose} customIcon icon="close" className="close" />} />
      <DialogContent className="application-denied-content">
        <img className="photo" src={photo && photo.startsWith('http') ? photo : `${BACKEND_URL}/violations/image/${photo}`} alt="" />
      </DialogContent>
      <DialogFooter className="hff-footer">
        <div className="hff-footer-buttons">
          <Button className="hff-clear-data" variant="secondary" onClick={onClose}>Закрыть</Button>
        </div>
      </DialogFooter>
    </Dialog>
  );
}
